"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Service = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _constants = require("../constants");

// this defines public interface for specific auth-services
// ensuring that all possible implementations are consistent and interchangeable
var Service = /*#__PURE__*/function () {
  function Service(service) {
    (0, _classCallCheck2.default)(this, Service);
    this.service = service;
  }

  (0, _createClass2.default)(Service, [{
    key: "getAuthorizeUrl",
    value: function getAuthorizeUrl() {
      return this.service.getAuthorizeUrl();
    }
  }, {
    key: "getSignOutUrl",
    value: function getSignOutUrl() {
      return this.service.getSignOutUrl();
    }
  }, {
    key: "extractError",
    value: function extractError() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var explicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.service.extractError(redirectUrl, explicit);
    }
  }, {
    key: "extractSession",
    value: function extractSession() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.service.extractSession(redirectUrl);
    }
  }, {
    key: "extractIdToken",
    value: function extractIdToken() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.service.extractIdToken(redirectUrl);
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken(redirectUrl) {
      var rawAccessToken = sessionStorage[_constants.SESSION_KEY];

      if (rawAccessToken) {
        var storedAccessToken = JSON.parse(rawAccessToken);

        if (this.hasValidToken(storedAccessToken)) {
          return storedAccessToken;
        }
      }

      var token = this.service.getAccessToken(redirectUrl);

      if (token.accessToken) {
        sessionStorage[_constants.SESSION_KEY] = JSON.stringify(token);
      }

      return token;
    }
  }, {
    key: "restoreSession",
    value: function restoreSession() {
      var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage;
      var sessionString = storage.getItem(_constants.SESSION_KEY);

      if (typeof sessionString !== 'string' || sessionString.length === 0) {
        return undefined;
      }

      var session = JSON.parse(sessionString);

      if (!this.service.hasValidToken(session)) {
        this.invalidateSession();
        return undefined;
      }

      return session;
    }
  }, {
    key: "invalidateSession",
    value: function invalidateSession() {
      sessionStorage.removeItem(_constants.SESSION_KEY);
    }
  }, {
    key: "hasValidToken",
    value: function hasValidToken() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAccessToken();
      return token && token.decodedAccessToken && Date.now() / 1000 < token.decodedAccessToken.exp;
    }
  }]);
  return Service;
}();

exports.Service = Service;
//# sourceMappingURL=service.js.map